/* eslint-disable complexity */
import { Injectable, inject } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  ErrorMessage,
  RecoverSQAErrorMessages,
  recoverBySecurityQuestions,
  validateAnswerRequest
} from '@com-delta-idp/mnx-login-ui';
import { regexList } from '../../../validator/regex-list';
import { WIFI_PORTAL_SQA_SUBTITLE_TEXT } from '../../constants/login-constant';
import { LoginModalContent } from '../../models/aem';
import { WifiPortalService } from '../wifi-portal/wifi-portal.service';

@Injectable({
  providedIn: 'root'
})
export class RecoverSqaHelperService {
  securityQuestionsForRecoveryForm!: UntypedFormGroup;
  wifiPortalService = inject(WifiPortalService);
  createSecurityQuestionsForRecoveryForm(): UntypedFormGroup {
    this.securityQuestionsForRecoveryForm = new UntypedFormGroup({
      answer1: new UntypedFormControl(null, [
        Validators.required,
        this.security_answer1_check
      ]),
      answer2: new UntypedFormControl(null, [
        Validators.required,
        this.security_answer2_check
      ])
    });
    return this.securityQuestionsForRecoveryForm;
  }

  security_answer1_check(control: UntypedFormControl): {
    [s: string]: boolean;
  } {
    const value = control?.value?.value.trim();
    if (value === '') {
      return { INVALID_FIRST_SEC_ANS: true };
    } else if (value?.length < 4) {
      return { SEC_ANS_LESS_THAN_FOUR_CHAR: true };
    } else {
      if (value && value?.match(regexList.securityAnswer)) {
        return <{ [s: string]: boolean }>(<unknown>null);
      }
      return { INVALID_FIRST_SEC_ANS: true };
    }
  }

  // eslint-disable-next-line complexity
  security_answer2_check(control: UntypedFormControl): {
    [s: string]: boolean;
  } {
    const value = control?.value?.value.trim();
    if (value === '') {
      return { INVALID_SECOND_SEC_ANS: true };
    } else if (value?.length < 4) {
      return { SEC_ANS_LESS_THAN_FOUR_CHAR: true };
    } else {
      if (value && value?.match(regexList.securityAnswer)) {
        if (control.parent !== undefined) {
          const sqanswer2 = value?.toUpperCase();
          const sqanswer1 = control?.parent
            ?.get('answer1')
            ?.value?.value?.toUpperCase();

          if (sqanswer1 === sqanswer2) {
            return { ANS_IN_USE: true };
          }
        }
        return <{ [s: string]: boolean }>(<unknown>null);
      }
      return { INVALID_SECOND_SEC_ANS: true };
    }
  }

  validityCheckForFormSubmit(userInputFields: validateAnswerRequest): boolean {
    let validCheckPassed = false;
    validCheckPassed =
      userInputFields?.tlMaskInfo_answer1 && userInputFields?.tlMaskInfo_answer2
        ? true
        : false;
    return validCheckPassed;
  }

  getSQARecoveryScreenContent(
    loginModalContent: LoginModalContent
  ): recoverBySecurityQuestions {
    const { securityQuestionAnswers, pageHeader } = loginModalContent;
    return {
      pageHeader: {
        ...pageHeader,
        headerTitle: securityQuestionAnswers.headerTitle,
        headerSubTitle: this.wifiPortalService.getQueryParamsWFP().isWFP
          ? securityQuestionAnswers.headerSubTitle
            ? securityQuestionAnswers.headerSubTitle
            : WIFI_PORTAL_SQA_SUBTITLE_TEXT
          : ''
      },
      errors: this.getRecoverSQAErrorMessages(loginModalContent),
      ...securityQuestionAnswers
    };
  }

  getRecoverSQAFormControlName(control: string): string | void | undefined {
    for (const key of Object.keys(
      this.securityQuestionsForRecoveryForm.controls
    )) {
      if (key === control) return key;
    }
  }

  getRecoverSQAErrorMessages(
    loginModalContent: LoginModalContent
  ): RecoverSQAErrorMessages {
    let answer1ErrorMessage = '',
      answer2ErrorMessage = '',
      alertWarningErrorMessages = '';
    loginModalContent.errors.errorMessages.forEach((option: ErrorMessage) => {
      if (option['errorId'] === this.getRecoverSQAFormControlName('answer1')) {
        answer1ErrorMessage = option['errorMessageDescription'];
      }
      if (option['errorId'] === this.getRecoverSQAFormControlName('answer2')) {
        answer2ErrorMessage = option['errorMessageDescription'];
      }
      alertWarningErrorMessages = 'To continue, please correct the';
    });
    return {
      answer1ErrorMessage: answer1ErrorMessage,
      answer2ErrorMessage: answer2ErrorMessage,
      alertWarningErrorMessages: alertWarningErrorMessages,
      formAlertErrorMessage: ''
    };
  }

  getSQAFormAttributes() {
    return {
      errorCount: 0,
      submitAttempt: false,
      errorAlertBanner: false,
      answer1ControlTouched: false,
      answer2ControlTouched: false
    };
  }
}
